document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.dropdown.select-wrapper').forEach(dropdown => {
    const toggle = dropdown.querySelector('.dropdown-toggle');
    const optionsContainer = dropdown.querySelector('.dropdown-options');
    const selectedOptionSpan = dropdown.querySelector('.selected-option');
    const closeBtn = dropdown.querySelector('.dark-arrow');

    closeBtn.addEventListener('click', (e) => {
      optionsContainer.classList.remove('active');
    });

    toggle.addEventListener('click', (e) => {
      document.querySelectorAll('.dropdown-options.active').forEach(openOptions => {
        if (openOptions !== optionsContainer) {
          openOptions.classList.remove('active');
          openOptions.closest('.dropdown').querySelector('.custom-arrow').classList.remove('active');
        }
      });

      optionsContainer.classList.toggle('active');
      toggle.querySelector('.custom-arrow').classList.toggle('active');
      e.stopPropagation();
    });

    optionsContainer.querySelectorAll('p').forEach(optionP => {
      optionP.addEventListener('click', (e) => {
        const selectedText = optionP.textContent;
        const selectedValue = optionP.dataset.value;

        selectedOptionSpan.textContent = selectedText;
        dropdown.setAttribute('data-selected-value', selectedValue);

        optionsContainer.classList.remove('active');
        toggle.querySelector('.custom-arrow').classList.remove('active');
        e.stopPropagation();
      });
    });

    document.addEventListener('click', (e) => {
      document.querySelectorAll('.dropdown-options.active').forEach(options => {
        const dropdown = options.closest('.dropdown');
        if (dropdown && !dropdown.contains(e.target)) {
          options.classList.remove('active');
          dropdown.querySelector('.custom-arrow').classList.remove('active');
        }
      });
    });
  });
});